<template>
  <div>
    <h1>Error</h1>
  </div>
</template>

<script>
export default {
  name: 'Error',
  props: {
    sectionInfo: {
      type: Object
    }
  },
  created () {
    // eslint-disable-next-line no-console
    console.log('[ERROR MULTI_SECTION] : ', JSON.stringify(this.sectionInfo))
  }
}
</script>
